import * as React from 'react';
export const bokfSvg = React.forwardRef(function bokfSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F72548',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm14.4 12.95-3.19 3.15c.88.8 1.7 1.6 2.58 2.41 0 0 .75.74.89.8h2.85c.13-.06.27-.13.47-.4l2.79-2.81c-1.02-1-2.04-1.94-3.06-2.88-.2-.2-.4-.54-.68-.54h-2.44c.07 0-.07.14-.2.27zm-.37-2.77c-.7.06-.7 0-1.25.46L9.04 14.3c.27.33.55.53.9.8l4.09-4c.2-.19.48-.12.76-.12h3.05c.34.06.55.33.9.53l7.07 6.38c.2 0 .07 1.67.14 2.33l-.07.27-4.72 4.59s-.9.93-1.24.86h-7.63c-.62-.13-.55-.33-.97-.66l-4.99-4.4c-.34-.52-.2-2.25-.27-2.79l5.89 5.4c.41.32.2.46 1.1.66h6.59c.35-.07.55-.2.9-.47l4.16-4.06v-.06l-.97-.87-3.54 3.46c-.69.6-.9 1.13-1.8 1.33h-5.26c-.49-.07-.56-.2-.9-.53L6.6 17.83c-.62-.73-.55-1.13-.55-2.2v-.8l7.27 6.59c.35.27.77.13 1.18.2h3.54c.48 0 .62-.07 1.04-.4l3.53-3.4.07-.06-.97-.86-3.26 3.19c-.14.13-.97.93-1.18.86h-3.53c-.35 0-.28-.2-.42-.2L6.2 14.17l-.06-.07v-2.33c0-.13.27-.33.48-.53l.76-.73.49-.46 3.74-3.66c.2-.2.49-.27.83-.34h6.8c.06 0 .13.07.27.07l.2.07c.5.2.77.33 1.19.8l4.64 4.19c.49.73.35 1.92.35 2.86l-6.52-5.99c-.27-.2-.55-.13-.62-.13h-6.3c-.56 0-.77.33-1.12.73L7.1 12.64l.83.6 4.71-4.6c.2-.2.55-.2.9-.2h5.27c.14 0 .34.14.62.4l6.24 5.73c.28.13.14 1.13.2 2.73l-7.69-6.99c-.27-.26-.34-.13-.41-.2h-3.74v.07z',
      }),
    ),
  );
});
bokfSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bokf = {
  category: 'brand',
  colorable: false,
  name: 'bokf',
  svg: bokfSvg,
};
